import { Component, Input, OnInit } from '@angular/core';
import { GoBackService } from '../go-back.service';
import { Router } from '@angular/router';
import { forceRedirectTo } from '../utils';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
  @Input() enableSearch: boolean;
  @Input() enableGoBack: boolean;
  @Input() iconUrl: string;
  @Input() title = '';
  @Input() subtitle = '';
  @Input() searchValue = '';
  @Input() searchPath = '';
  @Input() searchPlaceholder = '';
  @Input() isGreen: boolean;
  @Input() backUrl: string = null;
  @Input() helpLinks = [];

  constructor(
    private goBackService: GoBackService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.goBackService.init(['/']);
  }

  get backRouterLink() {
    return this.goBackService.backRouterLink;
  }

  get backQueryParams() {
    return this.goBackService.backQueryParams;
  }

  goBack() {
    this.goBackService.goBack();
  }

  search(value?: string) {
    forceRedirectTo(this.router, this.searchPath, { search: value });
  }

  onSearchKeyPress(e: any, search?: string) {
    if (e.keyCode === 13) this.search(search);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/page-header/page-header.component.ts